
/**
 * @function Util
 * @exported true
 * @description A generic class of functions.
 * @return {React.Component}
 */
export default class Util {
    /**
     * @name getABI22Branding
     * @static
     * @returns {STRING}
     * @description Function that returns the branding passed by the child iframe ABI22.
     * Note that "window.abi22Branding" is set asynchronously and may not be available immediately.
     * Comp id "LoginContent" initially sets "abi22Branding" in the window object
     * which gives the rest of the components access to ABI22 branding.
     * @example 
       const abi22Branding = Util.getABI22Branding();
       let abi22Options = {};
     
       if(abi22Branding) {
         abi22Options = abi22Branding.options;
       }
     */
    static getABI22Branding() {
      return window.abi22Branding;
    }
}